import { observer } from 'mobx-react';
import AddParticipantsToGroupFormStore from '../Store';
import { Ready, ReadyToSubmit, Submitting } from '../Store/Types';
import Participant from './Participant';

interface Props {
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
  state: Ready | ReadyToSubmit | Submitting;
}

function ParticipantsForm({ addParticipantsToGroupFormStore, state }: Props) {
  return (
    <div className="max-h-[200px] overflow-auto">
      {state.participants.map((participant) => (
        <Participant
          key={participant.id}
          participant={participant}
          addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
        />
      ))}
    </div>
  );
}

export default observer(ParticipantsForm);
